import styled from "styled-components";

export const IconBarWrapper = styled.div`
  flex: flex-grow; /* To change spacing between 2 progress bar */
  ${
    "" /* flex-grow: ${(props) => props.current ? "3" : "initial" || "initial"}; */
  }
  display: flex;
  column-gap: 10px;
  justify-content: center;
  align-content: center;
  align-items: center;
  align-self: center;
  ${"" /* background-color: pink; */}
  ${
    "" /* min-height: 40px;
    min-width: 22px; */
  }
    ${
    "" /* height: ${(props) => props.current ? "max-content" : "22px" || "22px"}; */
  }
    ${"" /* max-width: 30%; */}
    ${"" /* max-height: 100%; */}
    ${"" /* background-color: red; */}
	.progressFill {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 22px;
    min-width: 22px;
    height: ${(props) => (props.current ? "40px" : "22px" || "22px")};
    width: ${(props) => (props.current ? "40px" : "22px" || "22px")};
    border-radius: 50%;
    background-color: ${(props) =>
      props.complete ? "#C4A167" : "#FFFFFF" || "#FFFFFF"};
    border: 2px solid #c4a167;
    animation: progressZoomOut 2s ease 0s 1;
    ${"" /* transform-origin: 0% 100%; */}
  }
  .progressContent {
    display: flex;
    justify-content: center;
    align-content: center;
    color: #ffffff;
    height: 100%;
    width: 100%;
    border-radius: inherit;
    color: #ffffff;
    margin: 0px auto;
    font-size: auto;
    text-align: center;
    line-height: 1.25;
    font-size: 15px;
  }
  .progressIcon {
    display: flex;
    justify-content: center;
    align-self: center;
    border-radius: inherit;
  }
  img {
    height: ${(props) => (props.current ? "15px" : "80%" || "80%")};
    max-width: ${(props) => (props.current ? "100%" : "80%" || "80%")};
    max-height: ${(props) => (props.current ? "100%" : "80%" || "80%")};
  }
  .progressTitle {
    display: ${(props) => (props.current ? "block" : "none" || "none")};
    max-width: 50px;
    font-family: "pf_handbook_proregular";
    line-height: 20px;
    font-size: auto;
    word-wrap: break-word;
    ${"" /* word-break: break-word; */}
    overflow-wrap: normal;
    overflow: visible;
    ${"" /* background-color: red; */}
  }

  @keyframes progressZoomOut {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
`;
